$(document).ready(function(){ 
  $(window).on('load', function() {
    if($('.collection-sticky').length > 0){
    var total_filter = JSON.parse($('.data-available-materials-json[type="application/json"]').html());
      $('[data-filter-type="material"]').each(function(){
        if (total_filter.indexOf($(this).data('filter-hand')) == -1) {
          $(this).attr('disabled', true)
        }
      })
    }
  });
  var cf_feed_data;
  function get_cf_data(data,filter_type){
    $('[data-filtered-html]').find('.prolist-grid-wrapper').each(function(){
      var $this = $(this);
      var filter_json = JSON.parse($(this).find('.category_collection_json[type="application/json"]').text());
      console.log($(this).find('.product-title a').text());
      console.log(filter_json);
      console.log(filter_type);
      if(filter_type.every(r => filter_json.includes(r))){
        $this.removeClass('hide-grid');
      }else{
        $this.addClass('hide-grid');
      }
    });

    if(filter_type == ''){
      $('[data-default-html]').show();
      $('[data-filtered-html]').hide();
    }else{
      $('[data-default-html]').hide();
      $('[data-filtered-html]').show();
    }
  }
  function get_category_filter_data(col_handle,filter_type){
    $('[data-filter-type]').each(function(){
      if($(this).hasClass('active')){
        var filter_val = $(this).attr('data-filter-value');
        filter_type.push(filter_val);
      }
    });
    if((cf_feed_data != undefined)&&(cf_feed_data != '')&&(cf_feed_data != null)){
      get_cf_data(cf_feed_data,filter_type);
    }else{
      $.get('/collections/' + col_handle + '?view=filter-feed', function(data){
        $('[data-filtered-html]').html(data);
        cf_feed_data = data;
        get_cf_data(data,filter_type);
      });
    }
    var target_filter = $('[data-selected-filters]').attr('data-selected-filters');
    var selected_html = '';
    $('[data-filter-type="'+target_filter+'"]').each(function(){
      var filter_value = $(this).data('filter-value')
      var active_index = filter_type.indexOf(filter_value)
      if (active_index > -1) {
        // add filter selected
        selected_html += '<button class="btn btn-selected-material btn-sm mr-2" data-filter-selected-value="'+filter_value+'">X '+filter_value+'</button>'
      }
    })
    if (selected_html) {
      selected_html += '<button class="btn btn-link btn-clear-all btn-sm mr-2" data-filter-selected-value-clear data-filter-selected-value="">Clear all</button>'
      $('[data-selected-filters] > div').html(selected_html);
      $('[data-selected-filters]').removeClass('hide');
    } else {
      $('[data-selected-filters]').addClass('hide');
    }
  }
  var dropdown_container = $('#dropdownMenuButton');
    dropdown_container.on('click', function(e){ 
      e.preventDefault();
        $(this).closest('.dropdown').find('.dropdown-menu').toggleClass('show');
    });
  $(document).on('click',function(e){
    if(!dropdown_container.is(e.target) && dropdown_container.has(e.target).length === 0){
      dropdown_container.closest('.dropdown').find('.dropdown-menu').removeClass('show');
    }
  });
    $('.cf-dropdown-overlay').on('click', function(e){ 
      e.preventDefault();
      $(this).closest('.dropdown').find('.dropdown-menu').toggleClass('show');
      $('.cf-dropdown-overlay').removeClass('active-overlay');
    });
  $('body').on('click','[data-filter-type]',function(e){
    e.preventDefault();
    var filter_type =[];
    var col_handle = $(this).closest('.category-bubble-filter').attr('data-collection-handle');
    $(this).toggleClass('active');
    
    get_category_filter_data(col_handle,filter_type);
    
  });
  $('body').on('click', '.active-bubble-filter [data-filter-selected-value]', function(e){
    e.preventDefault();
    var filter_type =[];
    var col_handle = $(this).closest('.selected-filters').attr('data-collection-handle');
    $(this).closest('.collection-filters').find('.category-bubble-filter button[data-filter-value="'+$(this).attr('data-filter-selected-value')+'"]').removeClass('active');
    get_category_filter_data(col_handle,filter_type);
  });
  
  $('body').on('click', '[data-selected-filters] [data-filter-selected-value-clear]', function(){
    var filter_type =[];
    var col_handle = $('[data-selected-filters]').attr('data-collection-handle');
    $('.category-bubble-filter button').removeClass('active');
    get_category_filter_data(col_handle,filter_type);  
  });
  
  
  $(window).scroll(function() {
    if($('.category_col_template').length > 0){
     var itemOffset = $('.category_col_template').offset().top;
      var scrollTop = $(window).scrollTop();
      if((scrollTop >= itemOffset )&&($('[data-collection-filters]').is(":visible")||$('.subcol_bubble_filter').is(":visible"))){
        
        var header = $('.ntheader_wrapper').outerHeight()-5,extra=0;
        if ($('.ju_Con').is(":visible")){
          if($(window).width() > 1024){
            extra = 8;
          }
          var app_header = $('.ju_Con').outerHeight() + header - extra;
        }else{
          app_header= header;
        }
        if($('.cat_toolbar.cat_stuck').is(':visible')&& $(window).width() < 1025){
          app_header+=$('.cat_stuck').outerHeight();
        }
        $('.collection-sticky').addClass('fixed-filter-sticky').css('top',app_header);
      }else{
      $('.collection-sticky').removeClass('fixed-filter-sticky');
      } 
    }
  });
  if( $('.cat_toolbar.cat_stuck_prepared.cat_stuck').is(':empty') ) {
    $('.cat_toolbar.cat_stuck_prepared.cat_stuck').css('padding', '0')
  }

   function isEmpty( el ){
      return !$.trim(el.html())
  }
  function got_length(){
    if($('.cat_toolbar.cat_stuck_prepared.cat_stuck').length){
         $('.cat_toolbar.cat_stuck_prepared.cat_stuck').hide();
      }else{
     setTimeout(function(){ got_length(); }, 500);
    }
  }

  if (isEmpty($('.cat_toolbar.cat_stuck_prepared.cat_stuck'))) {    
    setTimeout(function(){
      got_length();
    }, 2000)
  } 
});